module.exports = __webpack_public_path__ + "static/media/index.3c5bfcd.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/mapVideos/fujian/index.mp4
// module id = 7dAB
// module chunks = 6